var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", { staticClass: "vat small text-muted" }, [
    _vm._v(
      "\n    " +
        _vm._s(_vm.$translate("Ceres::Template.singleItemFootnote1")) +
        " " +
        _vm._s(_vm.$translate("Ceres::Template.singleItemInclVAT")) +
        _vm._s(_vm.$translate("Ceres::Template.singleItemExclusive")) +
        "\n    "
    ),
    _c(
      "a",
      {
        attrs: {
          "data-toggle": "modal",
          href: "#shippingscosts",
          title: _vm.$translate("Ceres::Template.singleItemShippingCosts")
        },
        on: {
          click: function($event) {
            return _vm.getShippingInfo()
          }
        }
      },
      [
        _vm._v(
          "\n    " +
            _vm._s(_vm.$translate("Ceres::Template.singleItemShippingCosts")) +
            "\n    "
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }